import { render, staticRenderFns } from "./menu-slot-planet.vue?vue&type=template&id=5e4fcd4c&"
import script from "./menu-slot-planet.vue?vue&type=script&lang=js&"
export * from "./menu-slot-planet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports